'use client';
import Ripple from "./Ripple.js";
export default Ripple;